import * as React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import _ from "lodash";
import { toast } from "react-toastify";
import { _post } from "../../../Api";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import { InputAdornment, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Divider from "@material-ui/core/Divider";
import Card from "@material-ui/core/Card";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import GetCurrency from "../../../helper/GetCurrency";
import Paper from "@material-ui/core/Paper";
import DeleteIcon from "@material-ui/icons/Delete";

export const periods = ["MONTHLY", "WEEKLY", "YEARLY"];
export const invoice_types = ["BOOKING", "INCASSO"];

export default function SpqrSubscriptions(props) {
  const [spqrSubscriptions, setSpSubscriptions] = React.useState(null);
  const [editSpSubscriptions, setEditSpSubscriptions] = React.useState(null);
  const editable = props.editable;
  const merchantId = parseInt(useParams().merchantId);
  const toast_values = {
    position: "bottom-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const initializeSpqrSubscriptions = () => {
    const subs = props.subscriptions.filter((sub) => sub.type === "SP_QR");
    setSpSubscriptions(_.cloneDeep(subs));
    setEditSpSubscriptions(_.cloneDeep(subs));
  };

  useEffect(initializeSpqrSubscriptions, []);

  const warning_triggered = (key, newsub) => {
    if (key === "meta price_per_qr" && newsub["price_per_qr"] < 0.01) {
      toast.error("The price cannot be zero or a negative number.", toast_values);
      return true;
    }
    if (key === "meta number_of_qrs" && newsub["number_of_qrs"] < 1) {
      toast.error("The number of qr codes cannot be less than one", toast_values);
      return true;
    }
    if (
      newsub["subscription_stopped"] &&
      new Date(newsub["subscription_started"]) > new Date(newsub["subscription_stopped"])
    ) {
      toast.error("End date has to be later than start date", toast_values);
      return true;
    }
  };

  const postSpqrSubscription = (id, key) => {
    const oldsub = spqrSubscriptions.find((sub) => sub.id === id);
    const newsub = editSpSubscriptions.find((sub) => sub.id === id);
    const equal = key.includes("meta")
      ? oldsub["meta"][key.replace("meta ", "")] === newsub["meta"][key.replace("meta ", "")]
      : oldsub[key] === newsub[key];
    let data = key.includes("meta")
      ? {
          [key.replace("meta ", "")]: newsub["meta"][key.replace("meta ", "")],
        }
      : {
          [key]: newsub[key],
        };
    if (key === "meta discount_percentage") {
      data = {
        discount_percentage: newsub["meta"][key.replace("meta ", "")] / 100,
      };
    }
    if (equal || warning_triggered(key, newsub)) {
      return;
    }
    _post("/nova/merchant/" + merchantId + "/subscription/" + id, data)
      .then(() => {
        toast.success("Saved SP QR subscriptions successfully!", toast_values);
        setSpSubscriptions(editSpSubscriptions);
      })
      .catch((error) => {
        console.log(error);
        toast.error("SP QR subscriptions could not be saved.", toast_values);
      });
  };

  const changeSpqrSubscription = (id, key, value) => {
    if (key !== "subscription_stopped" && !key.includes("meta") && value == null) return;
    const subs = _.cloneDeep(editSpSubscriptions);
    const currentSub = subs.findIndex((sub) => sub.id === id);
    if (key === "wefact_merchant") {
      subs[currentSub]["wefact_merchant"] = props.wefactMerchants.find((merchant) => merchant.id === value);
    } else if (key.includes("meta")) {
      const soleKey = key.replace("meta ", "");
      subs[currentSub]["meta"][soleKey] = value;
    } else {
      subs[currentSub][key] = value;
    }
    setEditSpSubscriptions(subs);
  };

  const openRemoveDialog = (id) => {
    props.setSelectedSubscription(id);
    props.setRemoveDialogType("sp_qr");
  };

  const openAddDialog = () => props.setAddDialogType("sp_qr");

  if (props.subscriptions == null || editSpSubscriptions == null || props.wefactMerchants == null) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Grid container direction="column" spacing={4}>
      <Grid container direction="row" spacing={2} style={{ marginTop: "20px" }}>
        <Grid item>
          <Typography variant={"h5"}>SP QR</Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            disabled={!editable}
            onClick={openAddDialog}
            startIcon={<AddIcon />}
            color="primary"
          >
            Subscription
          </Button>
        </Grid>
      </Grid>
      <Divider style={{ margin: "20px 0" }} />
      {editSpSubscriptions.map((subscription) => {
        if (editable) {
          return (
            <Grid item key={subscription.id}>
              <Card style={{ padding: "1em" }}>
                <Grid container direction={"row"} spacing={3}>
                  <Grid item>
                    <FormControl>
                      <InputLabel>debtor</InputLabel>
                      <Select
                        value={subscription.wefact_merchant_id}
                        onBlur={() => postSpqrSubscription(subscription.id, "wefact_merchant")}
                        onChange={(event) =>
                          changeSpqrSubscription(subscription.id, "wefact_merchant", event.target.value)
                        }
                      >
                        {props.wefactMerchants.map((merchant) => {
                          return (
                            <MenuItem value={merchant.id} key={merchant.id}>
                              {merchant.debtor_code + " " + merchant.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl>
                      <InputLabel>SP_merchant</InputLabel>
                      <Select
                        value={subscription.sp_merchant_id}
                        onBlur={() => postSpqrSubscription(subscription.id, "sp_merchant_id")}
                        onChange={(event) =>
                          changeSpqrSubscription(subscription.id, "sp_merchant_id", event.target.value)
                        }
                      >
                        {props.merchant.sp_merchants.map((sp_merchant) => {
                          return <MenuItem value={sp_merchant.id}>{"S" + sp_merchant.id}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <TextField
                      label="title"
                      value={subscription.name}
                      onBlur={() => postSpqrSubscription(subscription.id, "name")}
                      onChange={(event) => changeSpqrSubscription(subscription.id, "name", event.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="start date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        changeSpqrSubscription(subscription.id, "subscription_started", event.target.value)
                      }
                      onBlur={() => postSpqrSubscription(subscription.id, "subscription_started")}
                      value={(() => {
                        const index = subscription.subscription_started.indexOf("T");
                        return index > -1
                          ? subscription.subscription_started.slice(0, index)
                          : subscription.subscription_started;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="end date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        changeSpqrSubscription(subscription.id, "subscription_stopped", event.target.value)
                      }
                      onBlur={() => postSpqrSubscription(subscription.id, "subscription_stopped")}
                      value={(() => {
                        if (subscription.subscription_stopped == null) return "";
                        const index = subscription.subscription_stopped.indexOf("T");
                        return index > -1
                          ? subscription.subscription_stopped.slice(0, index)
                          : subscription.subscription_stopped;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <FormControl>
                      <InputLabel>period</InputLabel>
                      <Select
                        value={subscription.period}
                        onBlur={() => postSpqrSubscription(subscription.id, "period")}
                        onChange={(event) => changeSpqrSubscription(subscription.id, "period", event.target.value)}
                      >
                        {periods.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl>
                      <InputLabel>invoice type</InputLabel>
                      <Select
                        value={subscription.invoice_type}
                        onBlur={() => postSpqrSubscription(subscription.id, "invoice_type")}
                        onChange={(event) =>
                          changeSpqrSubscription(subscription.id, "invoice_type", event.target.value)
                        }
                      >
                        {invoice_types.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined">
                      <InputLabel>number</InputLabel>
                      <OutlinedInput
                        type="number"
                        labelWidth={60}
                        inputMode="numeric"
                        onBlur={() => postSpqrSubscription(subscription.id, "meta number_of_qrs")}
                        onChange={(event) =>
                          changeSpqrSubscription(
                            subscription.id,
                            "meta number_of_qrs",
                            event.target.value ? parseInt(event.target.value) : null
                          )
                        }
                        value={subscription.meta.number_of_qrs}
                        inputProps={{
                          min: 0,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <TextField
                      label="type"
                      type="text"
                      onChange={(event) =>
                        changeSpqrSubscription(subscription.id, "meta number_suffix", event.target.value)
                      }
                      onBlur={() => postSpqrSubscription(subscription.id, "meta number_suffix")}
                      value={subscription.meta.number_suffix}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined">
                      <InputLabel>price</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                        labelWidth={33}
                        onBlur={() => postSpqrSubscription(subscription.id, "meta price_per_qr")}
                        onChange={(event) =>
                          changeSpqrSubscription(
                            subscription.id,
                            "meta price_per_qr",
                            event.target.value ? parseFloat(event.target.value) : null
                          )
                        }
                        value={subscription.meta.price_per_qr}
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined">
                      <InputLabel>discount percentage</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        endAdornment={<InputAdornment position="end">{"%"}</InputAdornment>}
                        labelWidth={150}
                        onBlur={() => postSpqrSubscription(subscription.id, "meta discount_percentage")}
                        onChange={(event) =>
                          changeSpqrSubscription(
                            subscription.id,
                            "meta discount_percentage",
                            event.target.value ? parseFloat(event.target.value) : null
                          )
                        }
                        value={
                          subscription.meta.discount_percentage < 1
                            ? subscription.meta.discount_percentage * 100
                            : subscription.meta.discount_percentage
                        }
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Paper variant="elevation" style={{ padding: "1em" }}>
                      <Typography variant="h6">
                        {(() => {
                          if (
                            subscription.meta.number_of_qrs < 1 ||
                            subscription.meta.number_suffix == null ||
                            subscription.meta.price_per_qr < 0.01
                          ) {
                            return "";
                          } else {
                            return (
                              subscription.meta.number_of_qrs +
                              " " +
                              subscription.meta.number_suffix +
                              " " +
                              GetCurrency() +
                              " " +
                              subscription.meta.price_per_qr
                            );
                          }
                        })()}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        changeSpqrSubscription(subscription.id, "subscription_stopped", null);
                      }}
                      onMouseLeave={() => {
                        postSpqrSubscription(subscription.id, "subscription_stopped");
                      }}
                    >
                      Empty end date
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button startIcon={<DeleteIcon />} onClick={() => openRemoveDialog(subscription.id)} />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          );
        } else {
          return (
            <Grid item key={subscription.id}>
              <Card style={{ padding: "1em" }}>
                <Grid container direction={"row"} spacing={3}>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>debtor</InputLabel>
                      <Select
                        value={subscription.wefact_merchant_id}
                        onBlur={() => postSpqrSubscription(subscription.id, "wefact_merchant")}
                        onChange={(event) =>
                          changeSpqrSubscription(subscription.id, "wefact_merchant", event.target.value)
                        }
                      >
                        {props.wefactMerchants.map((merchant) => {
                          return <MenuItem value={merchant.id}>{merchant.debtor_code + " " + merchant.name}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>SP_merchant</InputLabel>
                      <Select
                        value={subscription.sp_merchant_id}
                        onBlur={() => postSpqrSubscription(subscription.id, "sp_merchant_id")}
                        onChange={(event) =>
                          changeSpqrSubscription(subscription.id, "sp_merchant_id", event.target.value)
                        }
                      >
                        {props.merchant.sp_merchants.map((sp_merchant) => {
                          return <MenuItem value={sp_merchant.id}>{"S" + sp_merchant.id}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <TextField
                      disabled
                      label="title"
                      value={subscription.name}
                      onBlur={() => postSpqrSubscription(subscription.id, "name")}
                      onChange={(event) => changeSpqrSubscription(subscription.id, "name", event.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      disabled
                      label="start date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        changeSpqrSubscription(subscription.id, "subscription_started", event.target.value)
                      }
                      onBlur={() => postSpqrSubscription(subscription.id, "subscription_started")}
                      value={(() => {
                        const index = subscription.subscription_started.indexOf("T");
                        return index > -1
                          ? subscription.subscription_started.slice(0, index)
                          : subscription.subscription_started;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      disabled
                      label="end date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        changeSpqrSubscription(subscription.id, "subscription_stopped", event.target.value)
                      }
                      onBlur={() => postSpqrSubscription(subscription.id, "subscription_stopped")}
                      value={(() => {
                        if (subscription.subscription_stopped == null) return "";
                        const index = subscription.subscription_stopped.indexOf("T");
                        return index > -1
                          ? subscription.subscription_stopped.slice(0, index)
                          : subscription.subscription_stopped;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>period</InputLabel>
                      <Select
                        value={subscription.period}
                        onBlur={() => postSpqrSubscription(subscription.id, "period")}
                        onChange={(event) => changeSpqrSubscription(subscription.id, "period", event.target.value)}
                      >
                        {periods.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>invoice type</InputLabel>
                      <Select
                        value={subscription.invoice_type}
                        onBlur={() => postSpqrSubscription(subscription.id, "invoice_type")}
                        onChange={(event) =>
                          changeSpqrSubscription(subscription.id, "invoice_type", event.target.value)
                        }
                      >
                        {invoice_types.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" disabled>
                      <InputLabel>number</InputLabel>
                      <OutlinedInput
                        type="number"
                        labelWidth={60}
                        inputMode="numeric"
                        onBlur={() => postSpqrSubscription(subscription.id, "meta number_of_qrs")}
                        onChange={(event) =>
                          changeSpqrSubscription(
                            subscription.id,
                            "meta number_of_qrs",
                            event.target.value ? parseInt(event.target.value) : null
                          )
                        }
                        value={subscription.meta.number_of_qrs}
                        inputProps={{
                          min: 0,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <TextField
                      disabled
                      label="type"
                      type="text"
                      onChange={(event) =>
                        changeSpqrSubscription(subscription.id, "meta number_suffix", event.target.value)
                      }
                      onBlur={() => postSpqrSubscription(subscription.id, "meta number_suffix")}
                      value={subscription.meta.number_suffix}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" disabled>
                      <InputLabel>price</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                        labelWidth={33}
                        onBlur={() => postSpqrSubscription(subscription.id, "meta price_per_qr")}
                        onChange={(event) =>
                          changeSpqrSubscription(
                            subscription.id,
                            "meta price_per_qr",
                            event.target.value ? parseFloat(event.target.value) : null
                          )
                        }
                        value={subscription.meta.price_per_qr}
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" disabled>
                      <InputLabel>discount percentage</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        endAdornment={<InputAdornment position="end">{"%"}</InputAdornment>}
                        labelWidth={150}
                        onBlur={() => postSpqrSubscription(subscription.id, "meta discount_percentage")}
                        onChange={(event) =>
                          changeSpqrSubscription(
                            subscription.id,
                            "meta discount_percentage",
                            event.target.value ? parseFloat(event.target.value) : null
                          )
                        }
                        value={subscription.meta.discount_percentage}
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Paper variant="elevation" style={{ padding: "1em" }}>
                      <Typography variant="h6">
                        {(() => {
                          if (
                            subscription.meta.number_of_qrs < 1 ||
                            subscription.meta.number_suffix == null ||
                            subscription.meta.price_per_qr < 0.01
                          ) {
                            return "";
                          } else {
                            return (
                              subscription.meta.number_of_qrs +
                              " " +
                              subscription.meta.number_suffix +
                              " " +
                              GetCurrency() +
                              " " +
                              subscription.meta.price_per_qr
                            );
                          }
                        })()}
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          );
        }
      })}
    </Grid>
  );
}
